import { TYPE_ADMIN, TYPE_OWNER, TYPE_USER } from "../enums/Enum";


export const RoleStatus = (number) => {
    switch (number) {
        case TYPE_USER:
            return "User"
        case TYPE_ADMIN:
            return "Admin"
        case TYPE_OWNER:
            return "Owner"
        default:
            break;
    }
}